module.exports = {
	removeSpace : function (str){
		return str.replace(" ", "");
	},
	
	getCheckedValue: function (radioObj) {
		if(!radioObj)
			return "";
		var radioLength = radioObj.length;
		if(radioLength == undefined)
			if(radioObj.checked)
				return radioObj.value;
			else
				return "";
		for(var i = 0; i < radioLength; i++) {
			if(radioObj[i].checked) {
				return radioObj[i].value;
			}
		}
		return "";
	},
    
    restrictType: function(field, type){
        var types = {
            phone: '()- 0123456789',
            number: '0123456789',
            alpha: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ '
        };
        
        var t = field;
        var v = types[type]; 
        
        var w = "";
        for (i=0; i < t.value.length; i++) {
            x = t.value.charAt(i);
            if (v.indexOf(x,0) != -1) {
                w += x;
            }
        }
        
        if(w == '' && type == 'number') {
            w = '0';
        }
        
        t.value = w;
    },
    
    increment: function (diff, ele){
        newVal = parseInt(ele.value) + parseInt(diff);
        if(newVal < 0)
        {
        	ele.value = 0
        } else {
            ele.value = newVal
        }
    }
};